import { FC, ReactNode } from 'react';
import SectionTitle from './title/SectionTitle';

export type PageSectionProps = {
  children: ReactNode;
  title?: string;
  fullWidth?: boolean;
  classes?: string;
  bottomGutter?: boolean;
};

const PageSection: FC<PageSectionProps> = ({
  children,
  title,
  classes = '',
  fullWidth = false,
  bottomGutter = true,
}) => {
  if (!fullWidth) {
    return (
      <section
        className={`${bottomGutter ? 'tw-mb-16' : ''} tw-mx-4 ${classes}`}
      >
        {title && <SectionTitle title={title} />}
        <div className="tw-max-w-page tw-mx-auto">{children}</div>
      </section>
    );
  }

  return (
    <section className={`${bottomGutter ? 'tw-mb-16' : ''} ${classes}`}>
      {title && <SectionTitle title={title} />}
      {children}
    </section>
  );
};

export default PageSection;
